import { Chip } from '@mui/material';
import { QuestionType } from '@/components/campaigns/CampaignQuestionsEditor/types';
import { QUESTION_TYPE_LABELS } from '@/components/campaigns/CampaignQuestionsEditor/constants';
import QuestionTypeIcon from './QuestionTypeIcon';

interface QuestionTypeChipProps {
    type: QuestionType;
    isSelected: boolean;
    onToggle: (type: QuestionType) => void;
}

const QuestionTypeChip: React.FC<QuestionTypeChipProps> = ({ type, isSelected, onToggle }) => {
    return (
        <Chip
            key={type}
            icon={<QuestionTypeIcon type={type} />}
            label={QUESTION_TYPE_LABELS[type]}
            color="primary"
            variant={isSelected ? 'filled' : 'outlined'}
            onClick={() => onToggle(type)}
            sx={{ cursor: 'pointer', fontSize: '12px', p: 0.15, px: 0.75 }}
        />
    );
};

export default QuestionTypeChip;
